import React from 'react'
import FrequencyForm from './FrequencyForm'
import { Range } from '@medeo/components'

const KidneyTarget = () => (
  <div>
    {' '}
    <Range
      min={0}
      max={200}
      step={1}
      color="#FF5D5D"
      key="systolic"
      label="Tension systolique (mmHg)"
      items={[
        {
          low: 55,
          nameLow: 'systolic-verylow',
          high: 130,
          nameHigh: 'systolic-veryhigh',
          color: '#F19E40'
        },
        {
          low: 70,
          nameLow: 'systolic-low',
          high: 120,
          nameHigh: 'systolic-high',
          color: '#57DA92'
        }
      ]}
    />
    <FrequencyForm name="systolic" />
    <Range
      min={0}
      max={200}
      step={1}
      label="Tension diastolique (mmHg)"
      color="#FF5D5D"
      key="diastolic"
      items={[
        {
          low: 55,
          nameLow: 'diastolic-verylow',
          high: 130,
          nameHigh: 'diastolic-veryhigh',
          color: '#F19E40'
        },
        {
          low: 70,
          nameLow: 'diastolic-low',
          high: 120,
          nameHigh: 'diastolic-high',
          color: '#57DA92'
        }
      ]}
    />
    <FrequencyForm name="diastolic" />
  </div>
)

export default KidneyTarget



// WEBPACK FOOTER //
// ./src/Goal/components/KidneyTarget.js